import { MetadataFieldType, MetadataValue } from '@/api/generatedApi';
import { BooleanInput } from './BooleanInput';
import { NumberInput } from './NumberInput';
import { TextInput } from './TextInput';

interface InputFieldProperties {
  fieldType: MetadataFieldType;
  value: MetadataValue | undefined;
  onChange: (value: MetadataValue) => void;
  onEnter?: () => void;
  autoFocus?: boolean;
  placeholder?: string;
  label?: string;
  'data-testid'?: string;
}

export const InputField = ({
  fieldType,
  value,
  onChange,
  onEnter,
  autoFocus,
  placeholder,
  label,
  'data-testid': dataTestId,
}: InputFieldProperties) => {
  if (fieldType === MetadataFieldType.Number) {
    return (
      <NumberInput
        autoFocus={autoFocus}
        value={value as number | undefined}
        onChange={value => onChange(value)}
        onEnter={onEnter}
        data-testid={dataTestId}
      />
    );
  }
  if (fieldType === MetadataFieldType.Boolean) {
    return (
      <BooleanInput
        autoFocus={autoFocus}
        value={value as boolean | undefined}
        onChange={value => onChange(value)}
        data-testid={dataTestId}
      />
    );
  }
  return (
    <TextInput
      placeholder={placeholder}
      label={label}
      onEnter={onEnter}
      autoFocus={autoFocus}
      value={value || ''}
      onChange={event => onChange(event.target.value)}
      autoComplete='off'
      data-testid={dataTestId}
    />
  );
};
